import React from 'react';

import { ReactComponent as LostPerson } from 'src/assets/clients-page/no-search-results.svg';

interface Props {
  searchFilter: string;
}

export enum ClientsTableMessageTestID {
  NoSearchResults = 'NoSearchResults',
}

export const ClientsTableMessage: React.FC<Props> = ({ searchFilter }) => {
  const noSearchResults = searchFilter !== '';

  return (
    <div
      className="w-full items-center flex flex-col"
      data-testid={ClientsTableMessageTestID.NoSearchResults}
    >
      <LostPerson className="mt-8" />
      <div className="mb-2 text-center font-extrabold text-2xl break-normal max-w-screen-sm">
        We didn't find any results
        {noSearchResults && ` for "${searchFilter}"`}.
      </div>
      <div className="my-4 text-center break-normal font-normal text-lg max-w-screen-sm">
        {searchFilter
          ? 'Make sure everything is spelled correctly, or try different keywords.'
          : 'Try different filters.'}
      </div>
    </div>
  );
};
